import { Box, Button, Stack, Typography, alpha } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import { Cifra, Rotulo } from 'src/components/ui/casa';

const marco = {
  alignSelf: 'stretch',
  border: '1px solid', borderColor: 'divider', borderRadius: 1.5,
  p: 1.75, bgcolor: 'background.paper',
};

function Fila({ etiqueta, cifra }) {
  return (
    <Stack direction="row" justifyContent="space-between" sx={{ py: 0.4, borderTop: '1px solid', borderColor: 'divider' }}>
      <Typography variant="body2" color="text.secondary">{etiqueta}</Typography>
      <Cifra tamano="s">{cifra}</Cifra>
    </Stack>
  );
}

function VistaPrevia({ tarjeta, vigente, onEnviar }) {
  const { titulo, detalle, rubros, movidas, rechazados } = tarjeta;
  return (
    <Stack spacing={1} sx={marco}>
      <Rotulo>{tarjeta.deshacer ? 'Vista previa del deshacer' : 'Vista previa'}</Rotulo>
      <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{titulo}</Typography>
      {detalle.length > 0 && (
        <Typography variant="body2" color="text.secondary">{detalle.join(' · ')}</Typography>
      )}
      {rubros.length > 0 && <Typography variant="body2">{rubros.join(', ')}</Typography>}
      {movidas.length > 0 && (
        <Box>
          <Rotulo sx={{ mb: 0.4 }}>Lo que pasa al rubro</Rotulo>
          {movidas.map((m) => <Fila key={m.coleccion} etiqueta={m.etiqueta} cifra={m.cantidad} />)}
        </Box>
      )}
      {tarjeta.totalesIguales && (
        <Typography variant="body2" color="text.secondary">Los totales de la obra (ingreso, egreso, avance, certificado) no cambian.</Typography>
      )}
      {rechazados.length > 0 && (
        <Box>
          <Rotulo sx={{ mb: 0.4 }}>No los toco</Rotulo>
          {rechazados.map((r) => (
            <Typography key={r.nombre} variant="body2">
              {r.nombre} <Box component="span" sx={{ color: 'warning.dark' }}>({r.motivo})</Box>
            </Typography>
          ))}
        </Box>
      )}
      <Stack direction="row" spacing={1} sx={{ pt: 0.5 }}>
        <Button size="small" variant="contained" disabled={!vigente} onClick={() => onEnviar(tarjeta.confirmar.mensaje)}>
          {tarjeta.confirmar.label}
        </Button>
        <Button size="small" disabled={!vigente} onClick={() => onEnviar(tarjeta.cancelar.mensaje)}>
          {tarjeta.cancelar.label}
        </Button>
      </Stack>
    </Stack>
  );
}

function BotonDeshacer({ tarjeta, vigente, onElegir }) {
  return (
    <Button
      size="small" startIcon={<UndoIcon fontSize="small" />} disabled={!vigente}
      onClick={() => onElegir(tarjeta.mensaje)}
      title={tarjeta.resumen || undefined}
      sx={{
        alignSelf: 'flex-start', textTransform: 'none',
        '&:hover': { bgcolor: (th) => alpha(th.palette.primary.main, 0.06) },
      }}
    >
      Deshacer lo que hice
    </Button>
  );
}

/** `onEnviar(mensaje)` manda el texto como si lo escribiera la persona. */
export default function TarjetasDelCopiloto({ tarjetas, vigente, onEnviar }) {
  if (!tarjetas.length) return null;
  return tarjetas.map((t, i) => {
    const key = `${t.tipo}-${i}`;
    if (t.tipo === 'vista_previa') return <VistaPrevia key={key} tarjeta={t} vigente={vigente} onEnviar={onEnviar} />;
    return <BotonDeshacer key={key} tarjeta={t} vigente={vigente} onElegir={onEnviar} />;
  });
}
